// extracted by mini-css-extract-plugin
module.exports = {"productDetail":"ReviewsSection_productDetail__Fvp57"};